/* global fetch:false */
import { contentActionCreator } from '../actions';
import { getContentApiUrl, getContentId, getPreviewToken } from '../selectors';

const fetchContent = async (apiUrl, uid, previewToken) => {
  let url = [apiUrl, uid].join('/');
  if (previewToken) {
    url += `?token=${encodeURIComponent(previewToken)}`;
  }

  const response = await fetch(url, {
    headers: {
      Accept: 'application/json',
    },
  });

  const data = await response.json();

  if (!response.ok) {
    const error = new Error((data.error && data.error.message) || 'Failed to fetch content');
    error.status = response.status;
    throw error;
  }

  return data;
};

export default store => next => action => {
  const prevState = store.getState();
  const prevUid = getContentId(prevState);

  const ret = next(action);
  const state = store.getState();
  const uid = getContentId(state);

  if (prevUid !== uid) {
    const apiUrl = getContentApiUrl(state);
    store.dispatch(contentActionCreator(fetchContent(apiUrl, uid, getPreviewToken(state))));
  }

  return ret;
};
